const prefix = '@@SCHEDULE_ASSIGNMENT_MODAL';

export const OPEN_MODAL = `${prefix}__OPEN_MODAL`;
export const CLOSE_MODAL = `${prefix}__CLOSE_MODAL`;
export const SET_DATES = `${prefix}__SET_DATES`;
export const SCHEDULE_ASSIGNMENT = `${prefix}__SCHEDULE_ASSIGNMENT`;
export const SET_ERROR = `${prefix}__SET_ERROR`;
